<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
#mynewcard .el-tabs__content{
  overflow: scroll;
}
.el-progress-bar__outer {
    height: 4px !important;
    background-color: #515467 !important;
}
.el-progress-bar__inner {
    background: linear-gradient(to right, #0096e4 , #7e2dca) !important;
}
.el-progress__text {
    display: none !important;
}
.el-progress-bar {
    padding-right: 0 !important;
    margin-right: 0 !important;
}
.bigTabs.el-tabs--card>.el-tabs__header {
  top: -10px;
  margin-bottom: 0;
  border-bottom: none !important;
}
.bigTabs .el-tabs__content {
    top: -48px;
    height: 100%;
}
.bigTabs .el-tabs__nav-wrap {
    z-index: 998;
}
.bigTabs .el-tabs__nav-scroll {
    display: flex;
    justify-content: center;
    height: 48px;
}
.bigTabs .el-tabs__nav.is-top {
  border: none !important;
}
.bigTabs .el-tabs__item.is-top.is-active {
  background-color: rgba(59, 84, 211, 0.8);
  color: #fff !important;
}
.bigTabs .el-tabs__item {
  padding: 0 30px !important;
  background-color: rgba(66, 65, 78, 0.8);
  color: #cfcfcf !important;
  font-size: 18px !important;
  border: none !important;
  margin: 0 5px;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
  box-shadow: 0 3px 3px rgba(0, 0, 0, 0.8);
}
.smallTabs .el-tabs__nav-scroll {
    display: flex;
    justify-content: flex-end;
}
.smallTabs .el-tabs__item.is-active {
    color: #fff;
    background-color: #3a415b;
}
.smallTabs .el-tabs__nav-wrap::after {
    height: 0;
}
.smallTabs .el-tabs__item {
    padding: 0 15px;
    color: #cfcfcf;
}
.smallTabs .el-tabs__active-bar {
    height: 0px;
}
.smallTabs .el-tabs__item.is-bottom:nth-child(2),.smallTabs .el-tabs__item.is-top:nth-child(2),.smallTabs .el-tabs__item.is-bottom:nth-child(2),.smallTabs .el-tabs__item.is-top:nth-child(2) {
    padding-left: 15px !important;
}
.smallTabs .el-tabs__item.is-bottom:last-child,.smallTabs .el-tabs__item.is-top:last-child,.smallTabs .el-tabs__item.is-bottom:last-child,.smallTabs .el-tabs__item.is-top:last-child {
    padding-right: 15px !important;
}
.smallTabs .el-tabs__header {
    margin: 0;
}
.smallTabs .el-tabs__content {
    background-color: #3a415b;
    height: 200px;
}
.el-dialog {
  background-color: #24272e !important;
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.6) !important;
}
.el-dialog__body{
  padding: 0 10px 15px !important;
}
@media (max-width: 1920px) {
  .el-dialog {
    margin: 50px auto !important;
  }
}
@media (max-width: 1366px) {
  .el-dialog {
    margin: 20px auto !important;
  }
  .el-dialog__header {
    padding: 5px 20px 5px !important;
  }
  .smallTabs .el-tabs__item {
      padding: 0 10px;
  }
  .smallTabs .el-tabs__item.is-bottom:nth-child(2),.smallTabs .el-tabs__item.is-top:nth-child(2),.smallTabs .el-tabs__item.is-bottom:nth-child(2),.smallTabs .el-tabs__item.is-top:nth-child(2) {
      padding-left: 10px !important;
  }
  .smallTabs .el-tabs__item.is-bottom:last-child,.smallTabs .el-tabs__item.is-top:last-child,.smallTabs .el-tabs__item.is-bottom:last-child,.smallTabs .el-tabs__item.is-top:last-child {
      padding-right: 10px !important;
  }
  .smallTabs .el-tabs__content {
      height: 150px;
  }
}
.el-table {
  background-color: transparent !important;
}
.el-table th.el-table__cell {
  background-color: transparent !important;
}
.el-table tr {
    background-color: transparent !important;
}
.el-dialog__headerbtn {
  top: 2px !important;
  right: 10px !important;
}
.el-table .el-table__cell {
  padding: 0 !important;
  color: #cfcfcf;
}
.el-table .cell {
  white-space: nowrap !important;
  line-height: 30px !important;
}
.el-table td.el-table__cell {
    border-bottom: none !important;
}
.el-table th.el-table__cell.is-leaf {
  border-bottom: 2px solid #252a40 !important;
}
.el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
    background: #3d435d !important;
}
.mini-table.el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
    background: #444c6d !important;
}
.el-table::before {
  height: 0 !important;
}
.el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
    background-color: transparent !important;
}
.el-dialog__headerbtn {
    top: 8px !important;
}
.el-dropdown-menu {
  background-color: #232031 !important;
  border: 1px solid #211f31 !important;
}
.el-popper[x-placement^=bottom] .popper__arrow::after {
    border-bottom-color: #232031 !important;
}
.el-popper[x-placement^=bottom] .popper__arrow {
    border-bottom-color: #211f31 !important;
}
.el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: #232031 !important;
}
</style>
